import { getSiteUrl } from './env';

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '0.0.0.0']);

const getWindowOrigin = () =>
  typeof window !== 'undefined' ? window.location.origin.replace(/\/$/, '') : '';

const parseUrl = (value: string) => {
  try {
    return new URL(value);
  } catch {
    return null;
  }
};

export const getPublicBaseUrl = () => {
  const origin = getWindowOrigin();
  const originParsed = parseUrl(origin);

  // In local development we should always use the active origin/port.
  if (originParsed && LOCAL_HOSTS.has(originParsed.hostname)) {
    return origin;
  }

  const configuredSiteUrl = (process.env.REACT_APP_SITE_URL || '').trim();

  if (configuredSiteUrl) {
    return configuredSiteUrl.replace(/\/$/, '');
  }

  if (origin) {
    return origin;
  }

  return getSiteUrl();
};

export const getPublicListUrl = (slug: string) => `${getPublicBaseUrl()}/${slug}`;

export const getShareBaseUrl = () => {
  const explicitShareUrl = (process.env.REACT_APP_SHARE_URL || '').trim();
  if (explicitShareUrl) {
    return explicitShareUrl.replace(/\/$/, '');
  }

  const publicUrl = parseUrl(getPublicBaseUrl());
  if (!publicUrl) {
    return getWindowOrigin();
  }

  if (LOCAL_HOSTS.has(publicUrl.hostname)) {
    return publicUrl.toString().replace(/\/$/, '');
  }

  const shareUrl = new URL(publicUrl.toString());
  shareUrl.hostname = `share.${shareUrl.hostname.replace(/^(share|api)\./i, '')}`;
  return shareUrl.toString().replace(/\/$/, '');
};

export const getShareListUrl = (slug: string) => {
  const shareBaseUrl = getShareBaseUrl();
  if (!shareBaseUrl) {
    return getPublicListUrl(slug);
  }

  const shareUrl = parseUrl(shareBaseUrl);
  if (!shareUrl || LOCAL_HOSTS.has(shareUrl.hostname)) {
    return getPublicListUrl(slug);
  }

  return `${shareBaseUrl}/${slug}`;
};
